import { render, staticRenderFns } from "./WordCloud.vue?vue&type=template&id=425ac6c4&scoped=true&"
import script from "./WordCloud.vue?vue&type=script&lang=js&"
export * from "./WordCloud.vue?vue&type=script&lang=js&"
import style0 from "./WordCloud.vue?vue&type=style&index=0&id=425ac6c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425ac6c4",
  null
  
)

export default component.exports